import React from "react";
import { appendEllipsis } from "../../../utils/helper";
import { getContentDetailsOnClick } from '../../../utils/utility'

const CardContent = ({ post, isExpandable, expanded, setExpanded }) => {
  const buttonClass =
    "bg-blue-700 rounded-lg py-3 px-3 text-center cursor-pointer";
  const buttonTextClass = "font-bold text-white text-xs lg:text-sm uppercase";

  return (
    <div adoberegion="card-content">
      {expanded ? (
        <div adoberegion="card-content"
          className="full-content"
          dangerouslySetInnerHTML={{ __html: post.fullContent }}
        />
      ) : (
        <div adoberegion="card-content"
          className="text-base font-normal mb-2"
          dangerouslySetInnerHTML={{ __html: post.description && appendEllipsis(post.description) }}
        />
      )}

      {isExpandable && (
        <div className="my-3 mx-auto" style={{ width: "120px" }} adoberegion="card-content">
          {expanded ? (
            <div className={buttonClass} onClick={setExpanded}  adoberegion="card-content">
              <h5 className={buttonTextClass} onClick={() =>
                getContentDetailsOnClick(post, 'less', 'card-content')
              }>Less</h5>
            </div>
          ) : (
            <div className={buttonClass} onClick={setExpanded}  adoberegion="card-content">
              <h5 className={buttonTextClass} onClick={() =>
                getContentDetailsOnClick(post, 'more', 'card-content')
              }>More</h5>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CardContent;
